<template>
    <li class="tags-list__tag" v-click-outside-with-exclusion="{exclude: ['currentValue'], handler: 'clickedOutside'}">
        <template v-if="!isNewSegment">
            <div v-show="!isEditing" ref="currentValue">
            <span style="cursor: pointer" @click.prevent="editValue">
                {{ currentValue.name }}
            </span>
                <a v-if="canBeDeleted" class="tags-list__tag__close" @click.prevent="removeSegment"></a>
            </div>

            <multiselect
                ref="multiselect"
                v-show="isEditing"
                v-model="currentValue"
                :multiple="false"
                track-by="value"
                label="name"
                placeholder="Select option"
                :options="options"
                select-label=""
                deselect-label=""
                class="multiselect-mid pl-2"
                @select="segmentChanged"
            />
        </template>

        <template v-else>
            <multiselect
                ref="multiselect"
                v-model="currentValue"
                :multiple="false"
                track-by="value"
                label="name"
                placeholder="Select option"
                :options="options"
                select-label=""
                deselect-label=""
                class="multiselect-mid pl-2"
                @close="selectionClosed"
            />
        </template>
    </li>
</template>

<script>
import multiselect from 'vue-multiselect'

export default {
    name: 'SettingsSegment',
    components: {
        multiselect,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        options: {
            type: Array,
            required: true,
        },
        canBeDeleted: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            currentValue: {name: '', value: ''},
            isEditing: false,
        }
    },

    mounted() {
        if (this.isNewSegment) {
            this.$refs.multiselect.activate()
        }
    },

    computed: {
        isNewSegment() {
            return !this.currentValue.value
        }
    },

    watch: {
        value: {
            handler(newValue) {
                this.currentValue = newValue
            },
            immediate: true
        },
    },

    methods: {
        editValue() {
            this.isEditing = true
            this.$refs.multiselect.activate()
        },
        clickedOutside() {
            this.isEditing = false
        },
        removeSegment() {
            this.$emit('removeSegment', this.type, this.value)
        },
        selectionClosed() {
            this.$emit('selectionClosed', this.type, this.currentValue)
        },
        segmentChanged(selectedOption) {
            this.$emit('segmentChanged', this.type, selectedOption, this.currentValue)
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
